export default __webpack_public_path__ + "f06ce1d9e24730352c2b2834cc52204f.svg";